module.exports = __webpack_public_path__ + "img/equipmnet-tracking-depth.530055bc.png";